module.exports = __webpack_public_path__ + "img/pic-3.32a5a369.png";